<footer>
  <section>
    <h2>{{ 'FOOTER.SHOP' | translate }}</h2>
    <p class="footer__text">Prolaz kod kazališta 2 ({{ 'FOOTER.PULA_CENTER' | translate }}) <span
      class="footer__text__regular">52100 Pula</span></p>
    <p class="footer__text">{{ 'FOOTER.MON_FRI' | translate }}: <span class="footer__text__regular">{{ 'FOOTER.10_22' | translate }}</span></p>
    <p class="footer__text">{{ 'FOOTER.SAT' | translate }}: <span class="footer__text__regular">{{ 'FOOTER.15_21' | translate }}</span></p>
    <p class="footer__text">{{ 'FOOTER.SUN' | translate }}: <span class="footer__text__regular">{{ 'FOOTER.CLOSED' | translate }}</span></p>
  </section>

  <section>
    <h2>{{ 'FOOTER.INFO' | translate }}</h2>
    <p>
      <a class="footer__text" href="mailto:podrska@ulaznice.hr?subject=Upit%20NK%20Istra">{{ 'FOOTER.CONTACT' | translate }}</a>
    </p>
    <ng-container *ngIf="isLogged">
      <p>
        <a class="footer__text" [routerLink]="['/update-profile']">{{ 'FOOTER.MY_ACCOUNT' | translate }}</a>
      </p>
    </ng-container>
  </section>

  <section>
    <h2>{{ 'FOOTER.RULES' | translate }}</h2>
    <p>
      <a class="footer__text" [routerLink]="['/terms-of-sale']">{{ 'FOOTER.TERMS_OF_SALE' | translate }}</a>
    </p>
  </section>

  <!--<section>
    <h2>{{ 'FOOTER.NEWSLETTER' | translate }}</h2>
    <p class="footer__text__newsletter bold">{{ 'FOOTER.NEWS_INFO' | translate }}</p>
    <div class="newsletter-field">
      <mat-form-field appearance="outline">
        <input
          class="footer__text__newsletter"
          matInput
          placeholder="email@email.hr"
          [formControl]="email"
          (blur)="updateErrorMessage()"
        />
        <mat-error *ngIf="email.invalid">{{ errorMessage() }}</mat-error>
      </mat-form-field>
      <button mat-icon-button type="button" (click)="handleNewsletter()">
        <mat-icon aria-hidden="false">send</mat-icon>
      </button>
    </div>
  </section>-->

  <section>
    <img priority alt="logo-footer.svg" height="1088" width="858" [ngSrc]="'img/istra/logo-footer.svg'"/>
  </section>
</footer>
